import { createRouter, createWebHistory } from "vue-router";

import { history } from "@/utils/history";

import { routes } from "./index";

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(_to, _from, _savedPosition) {
    // History management and scroll restoration are handled across navigation, history, scrolling
    // and the useScrollable composable.
    //
    // This is the router's default behavior.
    return { top: 0, left: 0 };
  },
  routes,
});

router.isReady().then(() => {
  // Initialize history when router is ready
  history.enter(router.currentRoute.value);

  // Listen for route changes to update our custom history.
  //
  // This callback is triggered just after navigating to a new route i.e
  // when entering the new route.
  router.afterEach((to, _from) => {
    history.enter(to);
  });
});
